import { Input, NumberInput, NumberInputField, Select, Td, Tooltip, Tr } from "@chakra-ui/react";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { ClientClassificationType } from "models/client_classification_type";
import { CompraSericoTypeItem } from "models/compras_type";
import { ProdutoItemType } from "models/product_item_type";
import { ProductType } from "models/product_type";
import { OptionType } from "models/select_mode";
import { useRef, useState } from "react";
import formatNumber from "views/admin/order/hooks/formatNumber";
import useMeasureUnit from "views/admin/order/measureUnit/hooks/useMeasureUnit";
import useProductOrder from "views/admin/order/product/hooks/useProductOrder";

interface IAddRowServico {
    showError: (title: string, msg: string) => void;
    produtos : ProductType[];
    addRowService : (item : CompraSericoTypeItem) => void;
}
const AddRowServico = ( {addRowService, produtos, showError} :IAddRowServico ) => {
    const [produtoTexto, setProdutoTexto] = useState("");
    const [produto, setProduto] = useState("");
    const [descricao, setDescricao] = useState("");
    const [unidade, setUnidade] = useState("");
    const [unidadeTexto, setUnidadeTexto] = useState("");
    const [quantidade, setQuantidade] = useState("1");
    const [valor, setValor] = useState("");
    const [total, setTotal] = useState(0);
    const produtoRef = useRef(null);
    const [selectedProdutoItens, setSelectedProdutoItens] =
    useState<ProdutoItemType>();
  const [unidadesDisponiveis, setUnidadesDisponiveis] = useState<
    ClientClassificationType[]
  >([]);
  const [unidadePadrao, setUnidadePadrao] =
    useState<ClientClassificationType>();




    const addRow1 = (valor: string) => {
        const dataValue = Number(valor);
        const minValue = selectedProdutoItens?.valorMin;
        const maxValue = selectedProdutoItens?.valorMax;
        if (dataValue < minValue) {
          showError(
            "Erro",
            "Valor menor que o mínimo configurado para esse item/produto"
          );
          setValor(Number(minValue).toFixed(2));
          return;
        }
    
        if (dataValue > maxValue) {
          showError(
            "Erro",
            "Valor maior que o máximo configurado para esse item/produto"
          );
          setValor(Number(maxValue).toFixed(2));
          return;
        }
        const total = Number(valor) * Number(quantidade);
        setTotal(total);
    
        if (Number(valor) > 0) {
          const prdUn = produtos.find((dp) => dp.id === produto);
          const add: CompraSericoTypeItem = {
            descricao: descricao,
            pedidoCompraId: "",
            produtoId: produto,
            quantidade: Number(quantidade),
            unidadeMedidaId: unidade,
            produtoNome: produtoTexto,
            unidadeNome: unidadeTexto,
            validade: "",
            valorUn: Number(valor),
            valorTotal: Number(total),
            id: "",
            produtoUnidadeId: selectedProdutoItens.id,
            produtoUnidade: prdUn.ProdutoUnidade,
          };
            addRowService(add);
            setProduto("");
            setDescricao("");
            setUnidade("");
            setQuantidade("1");
            setValor("");
            setProdutoTexto("");
            setUnidadeTexto("");
            setTotal(0);
            produtoRef.current.focus();
          
        }
      };
    
      const changeProduto = (item: string) => {
        const prdUn = produtos?.find((value) => value.id === item);
        const unDisp: ClientClassificationType[] = [];
        unidades?.forEach((v) => {
          const existe = prdUn?.ProdutoUnidade?.find(
            (un) => un.unidadeMedidaId === v.id
          );
          if (existe) {
            unDisp.push(v);
            if (existe.principal) {
              changeUnidade(existe.unidadeMedidaId);
              const selected = prdUn.ProdutoUnidade.find(
                (prd) => prd?.unidadeMedidaId === existe.unidadeMedidaId
              );
              if (selected) {
                setSelectedProdutoItens(selected);
                const media =
                  (Number(selected.valorMin) + Number(selected.valorMax)) / 2;
                setValor(Number(media).toFixed(2));
              }
              setUnidadePadrao({
                id: existe.unidadeMedidaId,
                idEmpresa: prdUn.idEmpresa,
                nome: v.nome,
              });
            }
          }
        });
    
        setUnidadesDisponiveis(unDisp);
        setProdutoTexto(prdUn.nome);
        setProduto(item);
      };
    
      const changeDescricao = (item: string) => {
        setDescricao(item);
      };
    
      const changeUnidade = (item: string) => {
        const un = unidades?.find((val) => val.id === item);
        const prdUn = produtos?.find((value) => value.id === produto);
        const selected = prdUn?.ProdutoUnidade.find(
          (prd) => prd?.unidadeMedidaId === item
        );
        if (selected) {
          setSelectedProdutoItens(selected);
          const media = (Number(selected.valorMin) + Number(selected.valorMax)) / 2;
          setValor(Number(media).toFixed(2));
        }
        setUnidade(item);
        setUnidadeTexto(un.nome);
      };
      const changeQuantidade = (item: string) => {
        setQuantidade(item);
      };
    
      const changeValor = (item: string) => {
        setValor(item);
      };
    
      const {
        showModal,
      } = useProductOrder();
      const { unidades } = useMeasureUnit();
    
        return (
            <Tr
            key={`linda-batata`}
            draggable={false}
          >
            <Td
              fontSize={{ sm: "14px" }}
              borderColor="transparent"
            >0.0</Td>
            <Td fontSize={{ sm: "14px" }} width={450} borderColor="transparent">
                <AutoComplete<OptionType, false, GroupBase<OptionType>>
                  size="md"
                  onChange={(e) => changeProduto(e.value)}
                  placeholder="Buscar..."
                  ref={produtoRef}
                  name={`produto`}
                  options={produtos?.map((item) => {
                    return {
                      label: item?.nome,
                      value: item?.id,
                    };
                  })}
                />
    
    
            </Td>
            <Td fontSize={{ sm: "14px" }} borderColor="transparent" width={350}>
              <Input
                isRequired={false}
                fontSize="sm"
                value={descricao}
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Digite a Descrição"
                fontWeight="500"
                name={`descricao-`}
                border={"none"}
                size="md"
                onChange={(e) => changeDescricao(e.target.value)}
              />
            </Td>
    
            <Td fontSize={{ sm: "14px" }} borderColor="transparent" width={250}>
              <Select
                size="md"
                onChange={(e) => changeUnidade(e.target.value)}
                defaultValue={unidadePadrao?.id}
                name={`unidade-`}
              >
                {unidadesDisponiveis?.map((item) => (
                  <option value={item.id}>{item.nome}</option>
                ))}
              </Select>
            </Td>
    
            <Td fontSize={{ sm: "14px" }} borderColor="transparent" width={150}>
              <NumberInput
                precision={0.0}
                step={1}
                min={1}
                name={`quantidade-`}
                value={quantidade}
                onChange={(e) => changeQuantidade(e)}
              >
                <NumberInputField  />
              </NumberInput>
            </Td>
            <Td fontSize={{ sm: "14px" }} borderColor="transparent" width={200}>
              <Tooltip
                label={`O valor deve ser entre ${formatNumber(
                  isNaN(Number(selectedProdutoItens?.valorMin)) ? 0 : formatNumber(Number(selectedProdutoItens?.valorMin))
                )} e ${formatNumber(
                  isNaN(Number(selectedProdutoItens?.valorMax)) ? 0 : formatNumber(Number(selectedProdutoItens?.valorMax))
                )}`}
              >
                <Input
                  isRequired={false}
                  fontSize="sm"
                  value={valor}
                  ms={{ base: "0px", md: "0px" }}
                  type="text"
                  placeholder="valor"
                  name={`valor`}
                  fontWeight="500"
                  border={"none"}
                  size="md"
                  onChange={(e) => changeValor(e.target.value)}
                  onBlur={(e) => addRow1(e.target.value)}
                />
              </Tooltip>
            </Td>
    
            <Td fontSize={{ sm: "14px" }} borderColor="transparent" width={180}>
              {formatNumber(Number(total))}
            </Td>
            <Td fontSize={{ sm: "14px" }} borderColor="transparent"></Td>
          </Tr>
        )
    
    }

export default AddRowServico;


